import { Component, Input } from '@builder.io/sdk';

import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

import { idField } from 'utils/builder/fields';

const trustbarFields = [
  idField,
  {
    name: 'logos',
    type: 'list',
    subFields: [imageField('logo')],
    helperText: 'Add one or more logos to display in this trust bar.',
  },
] as const satisfies DeepReadonly<Input[]>;

export const trustBarsFields = [
  {
    name: 'heading',
    type: 'string',
    defaultValue: 'Trusted by SaaS Product & Development Teams',
    helperText: 'Heading text displayed above the trust bar logos.',
  },
  {
    name: 'trustBars',
    type: 'list',
    subFields: trustbarFields,
    helperText: 'Add multiple trust bar groups, each containing one or more logos.',
  },
] as const satisfies DeepReadonly<Input[]>;

const trustbarComponentFields = [...sectionFields, ...trustBarsFields] as const satisfies DeepReadonly<Input[]>;

const trustbarConfig = {
  name: 'trustbar',
  inputs: trustbarComponentFields,
} as Component;

export type TrustbarConfigProps = GenerateBuilder<typeof trustbarComponentFields>;

export default trustbarConfig;
